module.exports = __webpack_public_path__ + "img/plus.d61d8aac.svg";